import React, { useEffect, useMemo, useState } from 'react'
import { useTable, useSortBy, useGlobalFilter, usePagination, useBlockLayout, useFlexLayout } from 'react-table'
import { useSticky } from 'react-table-sticky'
import axios from 'axios'
import { Styles } from './TableStyles'
import { COLUMNS } from './Columns'
import  GlobalFilter  from './GlobalFilter'
import { Checkbox } from './Checkbox'
import '../index.css';

const Table = () => {
    
    const [loadingData, setLoadingData] = useState(true);
    const [data,setData] = useState([]);
   
    useEffect(() => {
        function getData(){
            axios.get("https://innounita.univ-unita.eu/backend/companies")
            .then((response) => {
                setData(response.data)
                setLoadingData(false)
                console.log("asvasgag")
            });
        }
        if (loadingData) {
            getData();
        }
    },[]);
    
    const columns = useMemo(() => COLUMNS, [])
    const tableInstance = useTable(
        {
          columns,
          data,
          initialState: {
            sortBy: [
              {
                id: "id",
                isSorted: true,
              },
            ],
          },
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useFlexLayout, 
      );
      

    const {getTableProps, getTableBodyProps, headerGroups, page, nextPage, previousPage, canNextPage, canPreviousPage, pageOptions, gotoPage, pageCount, setPageSize, prepareRow, allColumns, getToggleHideAllColumnsProps, state, setGlobalFilter} = tableInstance
    const { globalFilter, pageIndex, pageSize } = state
    return (
        <>
            <div className="table-body">
                <div className="table-container">
                    <div className="table-background">
                        <div>
                            <div>
                                <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter}  />&nbsp;&nbsp;
                                {/* <span>
                                    <Checkbox {...getToggleHideAllColumnsProps()}/>&nbsp;Toggle All&nbsp;&nbsp;
                                </span>
                                {
                                    allColumns.map(column => (
                                        <span key={column.id}>
                                            <label>
                                                <input type='checkbox' {...column.getToggleHiddenProps()}></input>
                                                &nbsp;{column.Header} &nbsp;&nbsp;
                                            </label>
                                        </span>
                                    ))
                                } */}
                            </div>
                            <br/>
                            <Styles>
                            <div {...getTableProps()} className="table table-flex" >
                                    <div className="header">
                                        {headerGroups.map((headerGroup) => (
                                            <div {...headerGroup.getHeaderGroupProps()} className="tr">
                                                {headerGroup.headers.map((column) => (
                                                    <div {...column.getHeaderProps(column.getSortByToggleProps())} className="th">
                                                        {column.render('Header')}
                                                        <span>
                                                            {column.Header != ' ' ? (column.isSorted ? column.isSortedDesc ? ' ↓ ' : ' ↑ ' : ' ⇅ ') : ''}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                    <div {...getTableBodyProps()} className="body">
                                        {page.map((row) => {
                                            prepareRow(row)
                                            return(
                                                <div {...row.getRowProps()} className="tr ">
                                                    {row.cells.map((cell) => {
                                                        return <div{...cell.getCellProps()} className="td centered-table">{cell.render('Cell')}</div>
                                                    })}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </Styles>
                            <div >
                                <span>
                                    Page{' '}
                                    <strong>
                                        {pageIndex + 1} of {pageOptions.length}
                                    </strong> {' '}
                                </span>
                                <span>
                                    | Go to Page: {' '}
                                    <input 
                                        style={{width: '50px'}}
                                        type='number'
                                        min="1"
                                        defaultValue={pageIndex + 1}
                                        onChange={e => {
                                            const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
                                            gotoPage(pageNumber)
                                        }}
                                    />
                                </span>
                                <select value= {pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                                    {
                                        [10, 25, 50].map(pageSize => (
                                            <option key={pageSize} value={pageSize}>
                                                Show {pageSize}
                                            </option>
                                        ))
                                    }
                                </select>
                                <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{'<<'}</button>
                                <button onClick={() => previousPage()} disabled={!canPreviousPage}>Previous</button>
                                <button onClick={() => nextPage()} disabled={!canNextPage}>Next</button>
                                <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{'>>'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Table;
